<template>
  <div>
    <h6>
      <span class="text-muted"
        >TIPO DE REAJUSTE DO
        {{
          stock_item.stock_item_type == "PRODUCT" ? "PRODUTO" : "MEDICAMENTO"
        }}:</span
      >
      {{
        {
          REAJUSTE_MANUAL: "REAJUSTE MANUAL",
          REAJUSTE_VALOR_MEDIO: "REAJUSTE VALOR MÉDIO (AUTOMÁTICO)",
          REAJUSTE_MAIOR_VALOR: "REAJUSTE MAIOR VALOR (AUTOMÁTICO)",
        }[readjustment]
      }}
    </h6>
    <div v-if="item && readjustment == 'REAJUSTE_MANUAL'">
      <div class="d-flex align-items-center" v-if="item.type == 'PRODUCT'">
        <h6 class="m-0">
          <span class="text-muted">VENDA:</span>
          R$
          {{
            item.product_sale ? formatPrice(item.product_sale) : "NÃO INFORMADO"
          }}
        </h6>
        <v-btn
          v-if="item.product_sale && item.product_sale != 0"
          small
          class="btn-edit ml-2"
          @click="selectByManual"
        >
          <i class="fas fa-check mr-2 text-twenty"></i> ESCOLHER
        </v-btn>
      </div>
      <div class="d-flex align-items-center" v-if="item.type == 'MEDICINE'">
        <h6 class="m-0">
          <span class="text-muted">VENDA:</span>
          R$
          {{
            item.medicine_sale
              ? formatPrice(item.medicine_sale)
              : "NÃO INFORMADO"
          }}
        </h6>
        <v-btn
          v-if="item.medicine_sale && item.medicine_sale != 0"
          small
          class="btn-edit ml-2"
          @click="selectByManual"
        >
          <i class="fas fa-check mr-2 text-twenty"></i> ESCOLHER
        </v-btn>
      </div>
    </div>
    <div
      class="d-flex align-items-center"
      v-if="item && readjustment == 'REAJUSTE_VALOR_MEDIO'"
    >
      <h6 class="m-0">
        <span class="text-muted">VALOR MÉDIO:</span>
        {{ formatPrice(average) }}
      </h6>
      <v-btn small class="btn-edit" @click="selectByAverage">
        <i class="fas fa-check mr-2 text-twenty"></i> ESCOLHER
      </v-btn>
    </div>
    <div
      class="d-flex align-items-center"
      v-if="item && readjustment == 'REAJUSTE_MAIOR_VALOR'"
    >
      <h6 class="m-0">
        <span class="text-muted">MAIOR VALOR:</span>
        {{ formatPrice(average) }}
      </h6>
    </div>
    <hr />
    <h6 class="title-pages">
      ÚLTIMO(S) LANÇAMENTO(S)
      <span v-if="item && readjustment == 'REAJUSTE_MAIOR_VALOR'">
        COM MAIOR VALOR
      </span>
    </h6>
    <div
      class="
        v-clean
        p-5
        text-center
        col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
      "
      v-if="stock_item_price_list.length == 0"
    >
      <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
    </div>
    <div v-if="stock_item_price_list.length > 0">
      <v-data-table
        dense
        :headers="[
          { text: 'VALOR', value: 'value', sortable: false },
          { text: 'DATA', value: 'created_at', sortable: false },
          { text: '', value: 'action', sortable: false },
        ]"
        :items="stock_item_price_list"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`item.value`]="{ item }">
          {{ formatReal(item.value) }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ moment(item.created_at).format("DD/MM") }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            v-if="readjustment == 'REAJUSTE_MAIOR_VALOR'"
            small
            class="btn-edit"
            @click="select(item)"
          >
            <i class="fas fa-check mr-2 text-twenty"></i> ESCOLHER
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import api from "../../../../services/api";

import { formatPrice, formatReal } from "../../../../lib/format";

import moment from "moment";

export default {
  name: "StockItemPriceList",

  props: {
    stock_item: { type: Object },
  },

  data() {
    return {
      stock_item_price_list: [],

      item: null,

      readjustment: "REAJUSTE_MANUAL",

      average: 0,

      loading: false,
    };
  },

  created() {
    let {
      stock_item: { stock_item_id },
    } = this;

    if (stock_item_id) {
      this.handleVerifyStockItemPriceList();
    }
  },

  methods: {
    moment,
    formatReal,
    formatPrice,

    async handleVerifyStockItemPriceList() {
      try {
        this.loading = true;

        let {
          stock_item: { stock_item_id },
        } = this;

        let params = { stock_item_id };

        const response = await api.get("/rest-home/stock/item/price-list", {
          params,
        });

        const { stock_item_price_list, readjustment, average, stock_item } =
          response.data;

        this.stock_item_price_list = stock_item_price_list;
        this.readjustment = readjustment;
        this.average = average;
        this.item = stock_item;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    selectByManual() {
      let {
        item: { type, product_sale, medicine_sale },
      } = this;

      let value = type == "PRODUCT" ? product_sale : medicine_sale;

      this.select({ value });
    },

    select(item) {
      let { value, manual = false } = item;

      let { stock_item } = this;

      let { amount } = stock_item;

      amount = String(amount).replace(",", ".");

      value = parseFloat(value) / 100;
      value = value.toFixed(2);

      let value_total = parseFloat(amount) * parseFloat(value);

      stock_item.value_total = formatReal(String(value_total));
      stock_item.value = formatReal(String(value_total));
      stock_item.unitary_value = formatReal(String(value));

      this.$emit("value", { ...stock_item, manual });
    },
  },
};
</script>
